// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_BLOG_PHOTOS = "Fotky ze zdi";
export const PHOTOS_SHOW_MORE = "V\u00edce ze zdi...";
